<div class="card plano-container">
    <div class="card-header">
        <p>{{ plano.nome }}</p>
    </div>
    <div class="card-body">
        <p class="valor-plano">
            {{ (isAnual ? plano.valorAnual : plano.valorMensal) | currency: 'BRL': 'symbol' }}<span>{{isAnual ? '/ano' : '/mês'}}</span>
        </p>
        <div class="descricao-container">
            <p class="descricao" [title]="plano.descricao">{{ plano.descricao }}</p>
        </div>

        <button *ngIf="showAtualizarPlano()" class="btn primary-white-button mt-2"
            (click)="selecionarPlano(plano)">
            Atualizar <i class="hgi hgi-stroke hgi-arrow-right-01"></i>
        </button>

        <div *ngIf="showPlanoAtual()" class="btn-plano-atual mt-2">
            Plano Atual <i class="hgi hgi-stroke hgi-tick-01"></i>
        </div>

        <div class="mt-3">
            <div *ngFor="let beneficio of getBeneficios()">
                <p class="text-beneficio">
                    <i class="hgi hgi-stroke hgi-checkmark-circle-04"></i>
                    {{ beneficio }}
                </p>
            </div>
        </div>
    </div>
</div>